import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-chevron-icon/jb-chevron-icon.css.ts
var jb_chevron_icon_css_default = i`:host{display:inline-block;height:var(--icon-size, 18px);width:var(--icon-size, 18px)}svg{fill:rgb(var(--rgb-primary, 20, 30, 85));transition:transform .3s,opacity .3s}svg:hover:not(.disabled){cursor:pointer;transform:translateX(3px)}.left{transform:scale(-1, 1)}.left:hover:not(.disabled){transform:scale(-1, 1) translateX(3px)}.down{transform:rotate(90deg)}.down:hover:not(.disabled){transform:rotate(90deg) translateX(3px)}.up{transform:rotate(-90deg)}.up:hover:not(.disabled){transform:rotate(-90deg) translateX(3px)}.disabled{opacity:.2}`;

export {
  jb_chevron_icon_css_default
};
